module.exports = __webpack_public_path__ + "img/pic05.547f31a3.png";